export default {
  data() {
    return {
      rentalShortcodes: {
        form: {
          code: "[WELCOME_FORM_URL]",
          name_en: "Welcome Form",
          name_fr: "Formulaire Bienvenue",
          name_pt: "Formulário de boas-vindas",
          name_es: "Formulario de bienvenida",
          id: "rentalForm",
        },
        checkinForm: {
          code: "[CHECKIN_FORM_URL]",
          name_en: "Checkin Form",
          name_fr: "Formulaire Checkin",
          name_pt: "Formulário de check-in",
          name_es: "Formulario de registro",
          id: "checkinForm",
        },
        name: {
          code: "[RENTAL:NAME]",
          name_en: "Rental name",
          name_fr: "Nom de l'appart",
          name_pt: "Nome do aluguel",
          name_es: "Nombre de alquiler",
          id: "rentalName",
        },
        hostFirstName: {
          code: "[RENTAL:HOSTFIRSTNAME]",
          name_en: "Rental host firstname",
          name_fr: "Prénom de l'hôte de location",
          name_pt: "Nome do host de aluguel",
          name_es: "Nombre del host de alquiler",
          id: "rentalHostFirstName",
        },
        hostLastName: {
          code: "[RENTAL:HOSTLASTNAME]",
          name_en: "Rental host lastname",
          name_fr: "Nom de famille de l'hôte de location",
          name_pt: "Sobrenome do host da locação",
          name_es: "Apellido del anfitrión de alquiler",
          id: "rentalHostLastName",
        },
        email: {
          code: "[RENTAL:EMAIL]",
          name_en: "Rental email",
          name_fr: "Email de l'appart",
          name_pt: "E-mail de aluguel",
          name_es: "Email de alquiler",
          id: "rentalEmail",
        },
        phone: {
          code: "[RENTAL:PHONE]",
          name_en: "Rental phone",
          name_fr: "Téléphone de l'appart",
          name_pt: "Telefone de locação",
          name_es: "Alquiler de telefono",
          id: "rentalPhone",
        },
        address: {
          code: "[RENTAL:ADDRESS]",
          name_en: "Rental address",
          name_fr: "Adresse de l'appart",
          name_pt: "Endereço de locação",
          name_es: "Dirección de alquiler",
          id: "rentalAddress",
        },
        zipcode: {
          code: "[RENTAL:ZIPCODE]",
          name_en: "Rental zipcode",
          name_fr: "Code postal",
          name_pt: "Código postal",
          name_es: "Código postal",
          id: "rentalZip",
        },
        city: {
          code: "[RENTAL:CITY]",
          name_en: "Rental city",
          name_fr: "Ville de l'appart",
          name_pt: "Cidade de aluguel",
          name_es: "Ciudad de alquiler",
          id: "rentalCity",
        },
        country: {
          code: "[RENTAL:COUNTRY]",
          name_en: "Rental country",
          name_fr: "Pays de l'appart",
          name_pt: "País de locação",
          name_es: "País de alquiler",
          id: "rentalCountry",
        },
        arrivalTime: {
          code: "[RENTAL:ARRIVAL_TIME]",
          name_en: "Rental arrival time",
          name_fr: "Heure d'arrivée de la location",
          name_pt: "Hora de chegada do aluguel",
          name_es: "Hora de llegada del alquiler",
          id: "rentalArrivalTime",
        },
        departureTime: {
          code: "[RENTAL:DEPARTURE_TIME]",
          name_en: "Rental departure time",
          name_fr: "Heure de départ de la location",
          name_pt: "Hora de partida do aluguel",
          name_es: "Hora de salida del alquiler",
          id: "rentalDepartureATime",
        },
      },
      guestShortcodes: {
        name: {
          code: "[GUEST:NAME]",
          name_en: "Guest name",
          name_fr: "Nom du voyageur",
          name_pt: "Nome do convidado",
          name_es: "Nombre del invitado",
          id: "guestName",
        },
        firstName: {
          code: "[GUEST:FIRST_NAME]",
          name_en: "Guest first name",
          name_fr: "Prénom du voyageur",
          name_pt: "Nome do convidado",
          name_es: "Nombre del huésped",
          id: "guestFirstName",
        },
        lastName: {
          code: "[GUEST:LAST_NAME]",
          name_en: "Guest last name",
          name_fr: "Nom du famille du voyageur",
          name_pt: "Sobrenome do convidado",
          name_es: "Apellido del invitado",
          id: "guestLastName",
        },
        email: {
          code: "[GUEST:EMAIL]",
          name_en: "Guest email",
          name_fr: "Email du voyageur",
          name_pt: "Email do convidado",
          name_es: "Correo electrónico de invitado",
          id: "guestEmail",
        },
        phone: {
          code: "[GUEST:PHONE]",
          name_en: "Guest phone",
          name_fr: "Téléphone du voyageur",
          name_pt: "Telefone convidado",
          name_es: "Teléfono invitado",
          id: "guestPhone",
        },
        city: {
          code: "[GUEST:CITY]",
          name_en: "Guest city",
          name_fr: "Ville du voyageur",
          name_pt: "Cidade convidada",
          name_es: "Ciudad invitada",
          id: "guestCity",
        },
        country: {
          code: "[GUEST:COUNTRY]",
          name_en: "Guest country",
          name_fr: "Pays du voyageur",
          name_pt: "País convidado",
          name_es: "País invitado",
          id: "guestCountry",
        },
        address: {
          code: "[GUEST:ADDRESS]",
          name_en: "Guest address",
          name_fr: "Adresse du voyageur",
          name_pt: "Endereço do convidado",
          name_es: "Dirección del invitado",
          id: "guestAddress",
        },
      },
      inquiryShortcodes: {
        arrive: {
          code: "[INQUIRY:ARRIVE]",
          name_en: "Inquiry arrive",
          name_fr: "Heure d'arrivée",
          name_pt: "Chegada do inquérito",
          name_es: "Consulta llegar",
          id: "inquiryArrive",
        },
        depart: {
          code: "[INQUIRY:DEPART]",
          name_en: "Inquiry depart",
          name_fr: "Heure de départ",
          name_pt: "Partida de inquérito",
          name_es: "Consulta salir",
          id: "inquiryDepart",
        },
        cost: {
          code: "[INQUIRY:COST]",
          name_en: "Inquiry cost",
          name_fr: "Prix total séjour",
          name_pt: "Custo da consulta",
          name_es: "Costo de la consulta",
          id: "inquiryCost",
        },
        price: {
          code: "[INQUIRY:PRICE]",
          name_en: "Inquiry net price",
          name_fr: "Prix net d'enquête",
          name_pt: "Preço líquido do inquérito",
          name_es: "Consulta precio neto",
          id: "inquiryPrice",
        },
        nights: {
          code: "[INQUIRY:NIGHTS]",
          name_en: "Inquiry nights",
          name_fr: "Nb de nuits",
          name_pt: "Noites de inquérito",
          name_es: "Noches de consulta",
          id: "inquiryNights",
        },
        adults: {
          code: "[INQUIRY:ADULTS]",
          name_en: "Inquiry adults",
          name_fr: "Nb d'adultes",
          name_pt: "Inquérito adultos",
          name_es: "Consulta adultos",
          id: "inquiryAdults",
        },
        children: {
          code: "[INQUIRY:CHILDREN]",
          name_en: "Inquiry children",
          name_fr: "Nb d'enfants",
          name_pt: "Crianças inquérito",
          name_es: "Consulta niños",
          id: "inquiryChildren",
        },
        bookDate: {
          code: "[INQUIRY:BOOK_DATE]",
          name_en: "Inquiry book date",
          name_fr: "Date de réservation",
          name_pt: "Data do livro de consulta",
          name_es: "Fecha del libro de consulta",
          id: "inquiryBookDate",
        },
      },
      bookingShortcodes: {
        bookingId: {
          code: "[BOOKING:ID]",
          name_en: "Booking ID",
          name_fr: "ID de réservation",
          name_es: "ID de reserva",
          name_pt: "ID da reserva",
          id: "bookingId",
        },
        bookingResId: {
          code: "[BOOKING:RES-ID]",
          name_en: "Booking reservation ID",
          name_fr: "Booking reservation ID",
          name_es: "Booking reservation ID",
          name_pt: "Booking reservation ID",
          id: "bookingResId",
        },
        confirmationCode: {
          code: "[BOOKING:CONFIRMATION-CODE]",
          name_en: "Booking confirmation code",
          name_fr: "Booking confirmation code",
          name_es: "Booking confirmation code",
          name_pt: "Booking confirmation code",
          id: "confirmationCode",
        },
        payment: {
          code: "[PAYLINK]",
          name_en: "Payment link",
          name_fr: "Lien de paiement",
          name_pt: "Enlace de pago",
          name_es: "Link de pagamento",
          id: "paymentLink",
        },
        paymentAmount: {
          code: "[PAYLINK:200]",
          name_en: "Payment link with amount",
          name_fr: "Lien de paiement avec montant manuel",
          name_pt: "Link de pagamento com valor",
          name_es: "Enlace de pago con importe",
          id: "paymentLinkAmount",
        },
        paymentPercent: {
          code: "[PAYLINKPERCENT:30]",
          name_en: "Payment link with %",
          name_fr: "Lien de paiement avec %",
          name_pt: "Link de pagamento com %",
          name_es: "Enlace de pago con %",
          id: "paymentLinkPercent",
        },
        deposit: {
          code: "[DEPOSITLINK]",
          name_en: "Deposit link",
          name_fr: "Lien de caution",
          name_pt: "Link de depósito",
          name_es: "Enlace de depósito",
          id: "depositLink",
        },
        depositAmount: {
          code: "[DEPOSITLINK:200]",
          name_en: "Deposit link with Amount",
          name_fr: "Lien de caution avec montant manuel",
          name_pt: "Depósito de link com Montante",
          name_es: "Enlace de depósito con Cantidad",
          id: "depositLinkAmount",
        },
        bookingChecking: {
          code: "[BOOKING:CHECKING]",
          name_en: "Booking Checking",
          name_fr: "Checkin",
          name_pt: "Check-in",
          name_es: "Registrarse",
          id: "bookingChecking",
        },
        bookingCheckout: {
          code: "[BOOKING:CHECKOUT]",
          name_en: "Booking Checkout",
          name_fr: "Checkout",
          name_pt: "Verificação de saída",
          name_es: "Revisa",
          id: "bookingCheckout",
        },
        bookingCheckingFormat: {
          code: "[CHECKING:DD-MM-YYYY]",
          name_en: "Booking Checking (DD-MM-YYYY)",
          name_fr: "Checkin (DD-MM-YYYY)",
          name_pt: "Check-in (DD-MM-YYYY)",
          name_es: "Registrarse (DD-MM-YYYY)",
          id: "bookingCheckingFormat",
        },
        bookingCheckoutFormat: {
          code: "[CHECKOUT:DD-MM-YYYY]",
          name_en: "Booking Checkout (DD-MM-YYYY)",
          name_fr: "Checkout (DD-MM-YYYY)",
          name_pt: "Verificação de saída (DD-MM-YYYY)",
          name_es: "Revisa (DD-MM-YYYY)",
          id: "bookingCheckoutFormat",
        },
        bookingPlatform: {
          code: "[BOOKING:PLATFORM]",
          name_en: "Platform",
          name_fr: "Plateforme",
          name_pt: "Plataforma",
          name_es: "Plataforma",
          id: "bookingPlatform",
        },
        bookingCleaningVideo: {
          code: "[BOOKING:CLEANINGVIDEO]",
          name_en: "Booking cleaning video",
          name_fr: "Vidéo ménage précédent",
          name_pt: "Vídeo de limpeza de reservas",
          name_es: "Reserva de vídeo de limpieza",
          id: "bookingCleaningVideo",
        },
        invoiceLink: {
          code: "[INVOICE:LINK]",
          name_en: "Invoice Link",
          name_fr: "Lien de facture",
          name_pt: "Link da fatura",
          name_es: "Enlace de factura",
          id: "invoiceLink",
        },
        contractLink: {
          code: "[CONTRACT:LINK]",
          name_en: "Contract Link",
          name_fr: "Lien contrat location",
          name_pt: "Enlace de contrato",
          name_es: "Link do contrato",
          id: "ContractLink",
        },
        openBuildingDoorLink: {
          code: "[OPENBUILDINGDOOR:LINK]",
          name_en: "Open Building Door Link",
          name_fr: "Lien Building ouverture de porte",
          name_pt: "Elo de porta do edifício aberto",
          name_es: "Enlace de puerta de edificio abierto",
          id: "openBuildingDoorLink",
        },
        closeBuildingDoorLink: {
          code: "[CLOSEBUILDINGDOOR:LINK]",
          name_en: "Close Building Door Link",
          name_fr: "Lien Building fermeture de porte",
          name_pt: "Fechar Link da porta do prédio",
          name_es: "Cerrar enlace de puerta del edificio",
          id: "closeBuildingDoorLink",
        },
        openOrCloseBuildingDoorLink: {
          code: "[OPENORCLOSEBUILDINGDOOR:LINK]",
          name_en: "Open Or Close Building Door Link",
          name_fr: "Lien ouverture et Building fermeture de porte",
          name_pt: "Abrir ou fechar o link da porta do edifício",
          name_es: "Abra o cierre el enlace de la puerta del edificio",
          id: "openOrCloseBuildingDoorLink",
        },
        openRentalDoorLink: {
          code: "[OPENRENTALDOOR:LINK]",
          name_en: "Open Rental Door Link",
          name_fr: "Lien ouverture  de porte",
          name_pt: "Abrir link da porta de aluguel",
          name_es: "Abrir enlace de puerta de alquiler",
          id: "openRentalDoorLink",
        },
        closeRentalDoorLink: {
          code: "[CLOSERENTALDOOR:LINK]",
          name_en: "Close Rental Door Link",
          name_fr: "Lien fermeture de porte",
          name_pt: "Fechar link da porta de aluguel",
          name_es: "Cerrar enlace de puerta de alquiler",
          id: "closeRentalDoorLink",
        },
        openOrCloseRentalDoorLink: {
          code: "[OPENORCLOSERENTALDOOR:LINK]",
          name_en: "Open Or Close Rental Door Link",
          name_fr: "Lien ouverture et fermeture de porte",
          name_pt: "Abrir ou fechar link de porta de aluguel",
          name_es: "Abrir o cerrar enlace de puerta de alquiler",
          id: "openOrCloseRentalDoorLink",
        },
        theKeysCode: {
          code: "[RENTALDOOR:CODE]",
          name_en: "Rental Door Code",
          name_fr: "Code de porte (digicode)",
          name_pt: "Código da porta de aluguel",
          name_es: "Código de puerta de alquiler",
          id: "rentalDoorCode",
        },
        lockCodeById: {
          code: "[RENTALDOOR:CODE:ID]",
          name_en: "Door Code By ID",
          name_fr: "Code de porte par id (digicode)",
          name_pt: "Código da porta por ID",
          name_es: "Código de puerta por ID",
          id: "lockCodeById",
        },
        assigneeChecking: {
          code: "[ASSIGNEE:CHECKING]",
          name_en: "Assignee Checking",
          name_fr: "Assignation Checkin",
          name_pt: "Check-in do cessionário",
          name_es: "Registro de cesionario",
          id: "assigneeChecking",
        },
        assigneeCheckout: {
          code: "[ASSIGNEE:CHECKOUT]",
          name_en: "Assignee Checkout",
          name_fr: "Assignation Checkout",
          name_pt: "Verificação de cessionário",
          name_es: "Pago del cesionario",
          id: "assigneeCheckout",
        },
        restPayment: {
          code: "[REST:PAYMENT]",
          name_en: "Rest Payment (website)",
          name_fr: "Lien avec reliquat de paiement (site web)",
          name_pt: "Pagamento Restante (site)",
          name_es: "Pago restante (sitio web)",
          id: "restPayment",
        },
        cityTaxes: {
          code: "[BOOKING:CITY_TAXES]",
          name_en: "City Taxes",
          name_fr: "Taxes de séjour",
          name_pt: "Taxa turística",
          name_es: "Tasa turística",
          id: "cityTaxes",
        },
        cleaningFees: {
          code: "[BOOKING:CLEANING_FEES]",
          name_en: "Cleaning Fees",
          name_fr: "Frais de ménage",
          name_pt: "Custos de limpeza",
          name_es: "Gastos de limpieza",
          id: "cleaningFees",
        },
        otherCharges: {
          code: "[BOOKING:OTHER_CHARGES]",
          name_en: "Other Charges",
          name_fr: "Autres frais",
          name_pt: "Outros custos",
          name_es: "Otros gastos",
          id: "otherCharges",
        },
      },
      paymentLinkShortcodes: {
        title: {
          code: "[PAYMENT:TITLE]",
          name_en: "Payment Link Title",
          name_fr: "Titre du lien de paiement",
          name_pt: "Título do pagamento",
          name_es: "Título de pago",
          id: "paymentLinkTitle",
        },
        description: {
          code: "[PAYMENT:DESCRIPTION]",
          name_en: "Payment Link Description",
          name_fr: "Lien de paiement Description",
          name_pt: "Descrição de pagamento",
          name_es: "Descripción de pago",
          id: "paymentLinkDescription",
        },
        amount: {
          code: "[PAYMENT:AMOUNT]",
          name_en: "Payment Link Amount",
          name_fr: "Montant du lien de paiement",
          name_pt: "Valor do link de pagamento",
          name_es: "Monto de enlace de pago",
          id: "paymentLinkAmount",
        },
        link: {
          code: "[PAYMENT:LINK]",
          name_en: "Payment Link",
          name_fr: "Lien de paiement",
          name_pt: "Enlace de pago",
          name_es: "Link de pagamento",
          id: "paymentLink",
        },
      },
      autoPaymentShortcodes: {
        amount: {
          code: "[AUTOPAYMENT:AMOUNT]",
          name_en: "Auto Payment Amount",
          name_fr: "Montant du paiement global",
          name_pt: "Montante do pagamento global",
          name_es: "Monto de pago global",
          id: "autoPaymentAmount",
        },
      },
    };
  },
};



// WEBPACK FOOTER //
// ./src/app/mixins/shortCodes.js